import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Cell,
    CartesianGrid,

} from "recharts";
import { Card, Col, Row, CardHeader, CardBody, CardFooter } from "reactstrap";
import { Volume } from "react-feather";

const BarChar1 = () => {

    const data = [
        {

            name: 'jan',
            Pumping: 74,
            Distribution: 45,
        },
        {

            name: 'feb',
            Pumping: 80,
            Distribution: 63,
        },
        {

            name: 'mar',
            Pumping: 66,
            Distribution: 45,
        },
        {

            name: 'apr',
            Pumping: 77,
            Distribution: 55,
        },
        {

            name: 'may',
            Pumping: 67,
            Distribution: 50,
        },
        {

            name: 'june',
            Pumping: 43,
            Distribution: 55,
        },
        {

            name: 'july',
            Pumping: 61,
            Distribution: 50,
        }
    ]


    return (
        <Col style={{ height: '100%' }}>


            <Card className="m-0 b-r-0">


                <CardHeader>
                    <h5 style={{ fontWeight: '600' }}>Distribution Vs Pumping</h5>
                </CardHeader>

                <CardBody>
                    <ResponsiveContainer width="100%" height={300} >
                        <BarChart
                            data={data}
                            barCategoryGap='0%'
                            barGap='1'

                        >

                            <XAxis dataKey="name" padding={{ left: 5, right: 5 }} />
                            <YAxis label={{
                                value: "Volume(m³)",
                                angle: -90,
                                position: "insideLeft",
                                style: { textAnchor: "middle", fontWeight: "bold" }
                            }} domain={[0, 100]}  />



                            <Tooltip formatter={(pumping: number, name: string) => [`${pumping}Volume(m³)`, name]}
                                cursor={false}
                                contentStyle={{
                                    backgroundColor: "white", // Tooltip box color
                                    borderRadius: "4px",
                                    border: "1px solid #ddd",
                                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                }}

                            />
                            <Bar
                                dataKey="Pumping"
                                animationDuration={600}
                                label={{ position: "top" }}
                                radius={[0, 0, 0, 0]}
                                barSize={30}
                                fill="#DC3545"

                            >

                                {data.map((entry: any, index) => (
                                    <Cell key={`cell-${index}`} />
                                ))}

                            </Bar>

                            <Bar
                                dataKey="Distribution"
                                animationDuration={600}
                                label={{ position: "top" }}
                                radius={[0, 0, 0, 0]}
                                barSize={30}
                                fill="#2B5F60"

                            >

                                {data.map((entry: any, index) => (
                                    <Cell key={`cell-${index}`} />
                                ))}

                            </Bar>


                        </BarChart>
                    </ResponsiveContainer>
                </CardBody>
                <CardFooter className="p-0">
                   <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem', gap: '2rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <div style={{
                                width: '12px',
                                height: '12px',
                                backgroundColor: '#DC3545',
                                borderRadius: '2px'
                            }} />
                            <span>Pumping</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <div style={{
                                width: '12px',
                                height: '12px',
                                backgroundColor: '#486A47',
                                borderRadius: '2px'
                            }} />
                            <span>Distribution</span>
                        </div>
                    </div>
                </CardFooter>


            </Card>

        </Col>

    )
}

export default BarChar1;